var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormaRoxa1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 300,
    viewBox: "0 0 1920 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1257 198C442.2 424 25.1667 190.167 -81.5 45L-262 -964.5L2229 -936.5L2340 415.5C2318.5 248.833 2071.8 -28 1257 198Z",
    fill: "#A92EE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1257 148.5C442.2 374.5 25.1667 140.667 -81.5 -4.5L-262 -1014L2229 -986L2340 366C2318.5 199.333 2071.8 -77.5 1257 148.5Z",
    fill: "#BC54F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormaRoxa1);
export default __webpack_public_path__ + "static/media/forma-roxa-1.d8af0301cf25383163ff9ab3f44c93ae.svg";
export { ForwardRef as ReactComponent };